// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.merge-card[data-v-276d79e9] {\n  height: 100vh;\n}\n.min-h-0[data-v-276d79e9] {\n  min-height: 0;\n}\n.overflow-y-auto[data-v-276d79e9] {\n  overflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
